import { useUserHasScopes } from './useUserHasScopes';
const BILLING_ADMIN_SCOPES = ['billing-read', 'billing-write'];
const SUPER_ADMIN_SCOPES = ['super-admin'];
export const useUserCanEditBilling = () => {
  const isBillingAdmin = useUserHasScopes(BILLING_ADMIN_SCOPES);
  const isSuperAdmin = useUserHasScopes(SUPER_ADMIN_SCOPES);
  return isBillingAdmin || isSuperAdmin;
};